// extracted by mini-css-extract-plugin
export default {"contentLeft":"stickyComponent_contentLeft__HPAwC","border":"stickyComponent_border__OPa0I","period":"stickyComponent_period__brrdV"};